import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";
import reportWebVitals from './reportWebVitals';

// ── Global Axios Config ─────────────────────────────────────────────────────
// Always send cookies for cross-origin requests
axios.defaults.withCredentials = true;

// Anti-caching interceptor: bust GET request cache on every call
axios.interceptors.request.use((config) => {
  if (config.method === 'get') {
    config.params = { ...config.params, _t: Date.now() };
  }
  config.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
  config.headers['Pragma'] = 'no-cache';
  return config;
});

// ── Service Worker: force kill any cached SW to always run fresh code ───────
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((reg) => reg.unregister());
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

reportWebVitals();
